import { render, staticRenderFns } from "./BusinessMatchContent.vue?vue&type=template&id=0006c2b8&scoped=true"
import script from "./BusinessMatchContent.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchContent.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchContent.vue?vue&type=style&index=0&id=0006c2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006c2b8",
  null
  
)

export default component.exports